import { useRouter } from "next/router";
import { Dispatch, SetStateAction, useEffect, useState } from "react";

import {
  ModalContentKind,
  ModalContentState,
  useModalContent,
} from "~/components/database/detail/lib";
import MobilePage from "~/components/database/page/[id]/MobilePage";
import PcPage from "~/components/database/page/[id]/PcPage";
import useIsSpMode from "~/lib/client/hooks/useIsSpMode";
import { DatabaseDetailTableContentQuery } from "~/lib/graphql/client";
import { useAppContext } from "~/pages/_app";
import { DatabaseDetailPageProps } from "~/pages/database/[id]";

export type Props = {
  props: DatabaseDetailPageProps;
  openResponseForm: (
    questions: DatabaseDetailPageProps["form"]["questions"]
  ) => void;
  openItemDetail: (
    response: DatabaseDetailTableContentQuery["form"]["responses"][number]
  ) => void;
  modalContent: ModalContentState;
  closeModal: () => void;
  setSuppressModalClosingWarning: Dispatch<SetStateAction<boolean>>;
};

export default function DatabaseDetailPage(props: DatabaseDetailPageProps) {
  const router = useRouter();
  const { currentUser } = useAppContext();
  const { hideModal, openResponseForm, openItemDetail, modalContent } =
    useModalContent();

  const [suppressModalClosingWarning, setSuppressModalClosingWarning] =
    useState(false);
  const isSpMode = useIsSpMode();

  const closeModal = () => {
    if (
      modalContent.__kind !== ModalContentKind.RESPONSE_FORM ||
      suppressModalClosingWarning
    ) {
      hideModal();
      return;
    }

    if (currentUser && confirm("編集内容を破棄しますか？")) {
      hideModal();
    }
  };

  useEffect(() => {
    router.beforePopState(() => {
      if (
        modalContent.__kind !== ModalContentKind.RESPONSE_FORM ||
        !currentUser ||
        suppressModalClosingWarning
      ) {
        return true;
      }

      return confirm("編集内容を破棄しますか？");
    });

    return () => {
      router.beforePopState(() => {
        return true;
      });
    };
  }, [currentUser, router, suppressModalClosingWarning, modalContent]);

  // ?open_drawer=1 がある場合は開く
  useEffect(() => {
    if (!!router.query.open_response_form) {
      openResponseForm(props.form.questions);
    }
  }, [router, props.form.questions, openResponseForm]);

  return (
    <>
      {isSpMode ? (
        <MobilePage
          props={props}
          closeModal={closeModal}
          modalContent={modalContent}
          openItemDetail={openItemDetail}
          openResponseForm={openResponseForm}
          setSuppressModalClosingWarning={setSuppressModalClosingWarning}
        />
      ) : (
        <PcPage
          props={props}
          closeModal={closeModal}
          modalContent={modalContent}
          openItemDetail={openItemDetail}
          openResponseForm={openResponseForm}
          setSuppressModalClosingWarning={setSuppressModalClosingWarning}
        />
      )}
    </>
  );
}
